import { DateTime } from 'luxon';

import { DateEntry } from '../types';

/**
 * Проверяет, относится ли дата к прошлому месяцу или раньше
 */
export const isPastMonth = (isoDate: string): boolean => {
  const date = DateTime.fromISO(isoDate);
  const now = DateTime.local();

  return date.year < now.year || (date.year === now.year && date.month < now.month);
};

/**
 * Проверяет, есть ли среди записей хотя бы одна с датой в прошлом месяце
 */
export const hasAnyPastMonth = (entries: DateEntry[]): boolean => {
  return entries.some((entry) => isPastMonth(entry.startDate));
};
